<div class="side-menu">
  <tds-side-menu aria-label="Side menu" id="side-menu" persistent [open]="isMenuOpened()">
    <tds-side-menu-overlay slot="overlay" (click)="mobileMenuAction(false)"></tds-side-menu-overlay>

    <tds-side-menu-close-button
      slot="close-button"
      aria-label="Close drawer menu"
      (click)="mobileMenuAction(false)"
    ></tds-side-menu-close-button>

    @for (menu of menus(); track menu.id) { @if (canShowItem(menu) && menu.subMenu &&
    hasVisibleChildren(menu)) {

    <tds-side-menu-dropdown default-closed>
      <tds-icon slot="icon" [name]="menu.icon" size="24px"></tds-icon>
      <span slot="label">{{ menu.title }}</span>

      <tds-side-menu-dropdown-list>
        @for (sub of menu.subMenu; track sub.id) { @if (canShowItem(sub)) {
        <tds-side-menu-dropdown-list-item
          [selected]="selectedMenu() === sub.path"
          [class.menu-item--disabled]="!hasAccess(sub.permissions)"
          [attr.title]="getAccessTooltip(sub)"
        >
          <button type="button" [disabled]="!hasAccess(sub.permissions)" (click)="navigate(sub)">
            {{ sub.title }}
          </button>
        </tds-side-menu-dropdown-list-item>
        } }
      </tds-side-menu-dropdown-list>
    </tds-side-menu-dropdown>

    } @else if (canShowItem(menu)) {

    <tds-side-menu-item
      [selected]="selectedMenu() === menu.path"
      [class.menu-item--disabled]="!hasAccess(menu.permissions)"
      [attr.title]="getAccessTooltip(menu)"
    >
      <button type="button" [disabled]="!hasAccess(menu.permissions)" (click)="navigate(menu)">
        <tds-icon [name]="menu.icon" size="24px"></tds-icon>
        {{ menu.title }}
      </button>
    </tds-side-menu-item>
    } }

    <div slot="end">
      <tds-side-menu-dropdown>
        @if (userphoto()) {
        <img
          slot="icon"
          [src]="userphoto()"
          alt="User avatar"
          height="34"
          width="34"
          class="user-avatar"
        />
        } @else {
        <tds-icon slot="icon" name="profile" size="24px"></tds-icon>
        }

        <tds-side-menu-user
          slot="label"
          [heading]="username()"
          [subheading]="useremail()"
        ></tds-side-menu-user>

        <tds-side-menu-dropdown-list-item (click)="toggleTheme()">
          <a>
            @if (theme.isDark()) {
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none">
              <path
                d="M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path d="M12 2v2" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
              <path d="M12 20v2" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
              <path
                d="M4.93 4.93l1.41 1.41"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
              />
              <path
                d="M17.66 17.66l1.41 1.41"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
              />
              <path d="M2 12h2" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
              <path d="M20 12h2" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
              <path
                d="M4.93 19.07l1.41-1.41"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
              />
              <path
                d="M17.66 6.34l1.41-1.41"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
            } @else {
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none">
              <g transform="translate(-2 0)">
                <path
                  d="M21 13.2A7.5 7.5 0 0 1 10.8 3 a6.9 6.9 0 1 0 10.2 10.2Z"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
            </svg>
            }

            <div class="tds-u-pl1">{{ (theme.isDark() ? 'Claro' : 'Escuro') }}</div>
          </a>
        </tds-side-menu-dropdown-list-item>

        <tds-side-menu-dropdown-list-item (click)="logout()">
          <a>
            <tds-icon name="exit"></tds-icon>
            <div class="tds-u-pl1">Logout</div>
          </a>
        </tds-side-menu-dropdown-list-item>
      </tds-side-menu-dropdown>
    </div>

    <tds-side-menu-collapse-button slot="sticky-end">Recolher</tds-side-menu-collapse-button>
  </tds-side-menu>
</div>
